import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './store';
import { Routes } from './routes.js';


/*
 * The application's root element
 *
 * @since 1.0.0
 */

const root = document.getElementById('root');




/*
 * Render the application
 *
 * @since 1.0.0
 */

ReactDOM.render(
  <Provider store={ store }>{ Routes }</Provider>, root
);

typeof window === 'object' && typeof window.devToolsExtension !== 'undefined'
  ? window.devToolsExtension()
  : f => f



// WEBPACK FOOTER //
// ./app/src/index.js